import { Link } from "react-router-dom";

/**
 * 5-services grid shown on the City Hub page.
 * - `city` : the city object (used for slug + display name).
 * - `services` : array describing the 5 appliance services with key, slug, icon, desc, brands.
 */
export default function CityServicesGrid({ city, services }) {
    return (
        <section className="bg-white border-y border-[var(--line)]">
            <div className="max-w-7xl mx-auto px-5 lg:px-10 py-16">
                <div className="divider-amber mb-5" />
                <h2 className="heading text-3xl lg:text-4xl font-extrabold">Nos 5 services à {city.name}</h2>
                <p className="mt-3 text-[var(--ink-soft)] max-w-3xl">
                    Cliquez sur un appareil pour accéder à la page dédiée avec pannes courantes, tarifs et conseils spécifiques à {city.name}.
                </p>
                <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5 mt-10">
                    {services.map((s) => {
                        const path = `/${s.slugPrefix}-${city.slug}`;
                        return (
                            <Link key={s.key} to={path} className="card-soft p-6 block group" data-testid={`service-card-${s.key}`}>
                                <div className="flex items-start gap-4">
                                    <span className="inline-flex items-center justify-center w-12 h-12 rounded-xl bg-[var(--paper)] text-[var(--amber)] shrink-0">
                                        <i className={`${s.icon} text-xl`} />
                                    </span>
                                    <div className="flex-1">
                                        <h3 className="heading text-lg font-extrabold text-[var(--navy)] group-hover:text-[var(--amber)]">
                                            {s.display} {city.name}
                                        </h3>
                                        <p className="text-sm text-[var(--ink-soft)] mt-2 leading-relaxed">{s.desc}</p>
                                        <p className="text-xs text-[var(--ink-soft)]/70 mt-3">
                                            <i className="fa-solid fa-tag text-[var(--amber)] mr-1" /> {s.brands}…
                                        </p>
                                        <p className="text-xs heading font-bold text-[var(--navy)] mt-4 inline-flex items-center gap-1.5">
                                            Voir la page <i className="fa-solid fa-arrow-right" />
                                        </p>
                                    </div>
                                </div>
                            </Link>
                        );
                    })}
                </div>
            </div>
        </section>
    );
}
